import {BackendLeaderboardPlayer, LeaderboardPlayer,} from "./types";

export const toFrontend = (players: BackendLeaderboardPlayer[]) : LeaderboardPlayer[] => {
    return players.map(player => ({
        id: player.userId,
        name: player.userName,
        points: player.totalPoints,
        position: player.currentPosition
    }))
}